// extracted by mini-css-extract-plugin
export default {"container":"XZ-z","list":"YZ-z"};